import { httpGet, httpPost, httpDelete } from "@/request/http";
import func from "@/funcs";

let path = "/purchases";

export default {
  get(id) {
    return httpGet(`${path}/${id}`);
  },
  getPages(params) {
    return httpGet(`${path}/pages`, params);
  },
  post(item) {
    return httpPost(path, item);
  },
  delete(id) {
    return httpDelete(`${path}/${id}`);
  },
  print(id) {
    func.printPdf.get(`${path}/${id}/report`);
  },
  getNoPays(id) {
    return httpGet(`/suppliers/${id}/purchases/nopay`);
  },
  getExcel() {
    func.getExcel.get(`${path}/foodexcel/example`, "匯入進貨單商品");
  },
  getExcelByPost(foods) {
    func.getExcel.post(`${path}/exportfood`, "匯入進貨單商品", foods);
  },
  postExcel(formData) {
    return func.postExcel(`${path}/importfood`, formData);
  },
};
